/* SPRINT 3 — sacred text for the Shaheed remembrance dua. Rendered respectfully
   as sacred text (Arabic prominent, transliteration + a faithful translation).
   Surah Al-Fatiha (1:1–7) and a Qur'anic maghfirah (forgiveness) dua (59:10). */

export interface Ayah { ar: string; tr: string; en: string }

export const AL_FATIHA: { title: string; ayat: Ayah[] } = {
  title: 'Surah Al-Fatiha',
  ayat: [
    { ar: 'بِسْمِ اللَّهِ الرَّحْمَٰنِ الرَّحِيمِ', tr: 'Bismillāhir-Raḥmānir-Raḥīm', en: 'In the name of Allah, the Most Gracious, the Most Merciful.' },
    { ar: 'الْحَمْدُ لِلَّهِ رَبِّ الْعَالَمِينَ', tr: 'Al-ḥamdu lillāhi Rabbil-ʿālamīn', en: 'All praise is for Allah, Lord of all the worlds.' },
    { ar: 'الرَّحْمَٰنِ الرَّحِيمِ', tr: 'Ar-Raḥmānir-Raḥīm', en: 'The Most Gracious, the Most Merciful.' },
    { ar: 'مَالِكِ يَوْمِ الدِّينِ', tr: 'Māliki yawmid-dīn', en: 'Master of the Day of Judgement.' },
    { ar: 'إِيَّاكَ نَعْبُدُ وَإِيَّاكَ نَسْتَعِينُ', tr: 'Iyyāka naʿbudu wa iyyāka nastaʿīn', en: 'You alone we worship, and You alone we ask for help.' },
    { ar: 'اهْدِنَا الصِّرَاطَ الْمُسْتَقِيمَ', tr: 'Ihdinaṣ-ṣirāṭal-mustaqīm', en: 'Guide us along the Straight Path.' },
    { ar: 'صِرَاطَ الَّذِينَ أَنْعَمْتَ عَلَيْهِمْ غَيْرِ الْمَغْضُوبِ عَلَيْهِمْ وَلَا الضَّالِّينَ', tr: 'Ṣirāṭal-ladhīna anʿamta ʿalayhim ghayril-maghḍūbi ʿalayhim wa laḍ-ḍāllīn', en: 'The path of those You have blessed — not of those who earned Your anger, nor of those who went astray.' },
  ],
}

/* Qur'an 59:10 — a dua of seeking forgiveness for those who came before in faith. */
export const MAGHFIRAH_DUA: Ayah = {
  ar: 'رَبَّنَا اغْفِرْ لَنَا وَلِإِخْوَانِنَا الَّذِينَ سَبَقُونَا بِالْإِيمَانِ وَلَا تَجْعَلْ فِي قُلُوبِنَا غِلًّا لِّلَّذِينَ آمَنُوا رَبَّنَا إِنَّكَ رَءُوفٌ رَّحِيمٌ',
  tr: 'Rabbanā-ghfir lanā wa li-ikhwāninal-ladhīna sabaqūnā bil-īmān…',
  en: 'Our Lord, forgive us and our brothers who preceded us in faith, and let not our hearts harbour rancour towards those who believe. Our Lord, You are truly Most Kind, Most Merciful.',
}
